import * as React from 'react';
import styled, { css } from 'styled-components';
import { Typography } from '../../../components/DesignSystemV2/Typography';
import { colorsV2 } from '../../../style/colors-v2';
import Sticky from 'react-stickynode';
import { fromScreen } from '../../../utils/media-query/responsive.util';
import { Rating } from '../Courses';
import { useStickyCourseContext } from './StickyCourseContext';

const CourseInfoWrapper = styled.div``;
const CourseInfo = styled.div`
  display: flex;
  align-items: center;
  .rating {
    margin-right: 4px;
  }
`;
const StickyCourseHeaderWrapper = styled.div`
  ${props =>
    props.show
      ? css`
          height: auto;
        `
      : css`
          display: none;
        `}
  ${fromScreen(1144)} {
    box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.04), inset 0px -1px 0px #d2d3d9;
    background-color: ${colorsV2.black5};
    ${CourseInfoWrapper} {
      max-width: 1120px;
      margin: 0 auto;
      padding: 12px 0;
    }
    // max-width: 740px;
    // margin: 0 auto;
  }
`;
const StickyCourseHeaderBase = ({ level, rating }) => {
  const { isEnabled, setEnabled } = useStickyCourseContext();
  return (
    <>
      <Sticky
        top={0}
        innerZ={500}
        onStateChange={state => {
          if (state.status === Sticky.STATUS_FIXED) {
            setEnabled(true);
          }
          if (state.status === Sticky.STATUS_ORIGINAL) {
            setEnabled(false);
          }
        }}
      >
        <StickyCourseHeaderWrapper show={isEnabled}>
          <CourseInfoWrapper>
            <Typography variant="bold/20-28">{level.levelDisplay}</Typography>
            <CourseInfo>
              <div className="rating">
                <Rating stars={rating.starsInFloat} />
              </div>
              {level.numOfStudent && (
                <Typography
                  style={{ color: colorsV2.black80 }}
                  variant="regular/12"
                >
                  {level.numOfStudent} học viên đã học
                </Typography>
              )}
            </CourseInfo>
          </CourseInfoWrapper>
        </StickyCourseHeaderWrapper>
      </Sticky>
    </>
  );
};

export const StickyCourseHeader = StickyCourseHeaderBase;
